<!-- eslint-disable vue/valid-v-for -->
<template>
  <el-container>
    
    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack()" :content="title">
      </el-page-header>
    </el-header>
    <el-main>
      <el-form ref="openclasslForm" :model="form" :rules="rules" label-width="140px" class="demo-ruleForm t_center"
               align="left" label-position="left">
        <el-form-item label="公开课名称" prop="openClassName">
          <el-input v-model="form.openClassName" placeholder="公开课名称"></el-input>
        </el-form-item>
        <el-form-item label="公开课英文名称" prop="openClassNameEn">
          <el-input v-model="form.openClassNameEn" placeholder="公开课英文名称"></el-input>
        </el-form-item>
        <el-form-item label="所属项目类别:" :inline="true" prop="courseCategoryId" style="width: 100%">
            <el-cascader
                expand-trigger="hover"
                change-on-select="true"
                size="small"
                :options="array1"
                :props="{ value: 'ccId', label: 'ccName'}"
                v-model="selectedOrgCategory"
                @change="changeCategory">
            </el-cascader>
          </el-form-item>
        <el-form-item label="公开课时间:"  :required="form.openBeginTime || form.openEndTime?true:false">
            <el-date-picker
                v-model="form.openBeginTime"
                type="datetime"
                placeholder="选择开始日期"
                value-format="yyyy-MM-dd HH:mm"
                :picker-options="startTime"
            >
            </el-date-picker>
            <span style="margin: 0px 10px;">-</span>
            <el-date-picker
                v-model="form.openEndTime"
                type="datetime"
                placeholder="选择结束日期"
                value-format="yyyy-MM-dd HH:mm"
                :picker-options="endTime"
            >
            </el-date-picker>
        </el-form-item>
        <el-form-item label="教师姓名" prop="teacherName">
          <el-input v-model="form.teacherName" placeholder="教师姓名"></el-input>
        </el-form-item>
        <el-form-item label="教师英文姓名" prop="teacherNameEn">
          <el-input v-model="form.teacherNameEn" placeholder="教师英文姓名"></el-input>
        </el-form-item>
        <el-form-item label="教师简介" prop="teacherIntroduction">
          <el-input v-model="form.teacherIntroduction" placeholder="教师简介"></el-input>
        </el-form-item>
        <el-form-item label="教师英文简介" prop="teacherIntroductionEn">
          <el-input v-model="form.teacherIntroductionEn" placeholder="教师英文简介"></el-input>
        </el-form-item>
        <el-form-item label="公开课简介" prop="openClassIntroduction">
          <el-input v-model="form.openClassIntroduction" placeholder="公开课简介"></el-input>
        </el-form-item>
        <el-form-item label="公开课英文简介" prop="openClassIntroductionEn">
          <el-input v-model="form.openClassIntroductionEn" placeholder="公开课英文简介"></el-input>
        </el-form-item>
        <el-form-item label="公开课图片:" prop="openClassPicture">
            <el-upload
                v-model="form.openClassPicture"
                name="upfile"
                :action="uploadURL"
                :headers="headers"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="pictureHandleRemove"
                :on-change="pictureOnChange"
                :on-success="fengmianHandleSuccess"
                :on-error="onError"
                :before-upload="imageBeforeAvatarUpload"
                :limit="1"
                :on-exceed="exceed"
                :file-list="openclassFileList"
                :show-file-list="true">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" size="tiny">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
          <el-form-item label="classin链接" prop="openClassLink">
          <el-input v-model="form.openClassLink" placeholder="classin链接"></el-input>
        </el-form-item>
        <el-form-item label="预约公开课链接" prop="openClassAppointmentLink">
          <el-input v-model="form.openClassAppointmentLink" placeholder="预约公开课链接"></el-input>
        </el-form-item>
        <el-form-item label="关联商品推荐:" :inline="true" style="width: 100%">
            <choseCommodity buttonName="+关联商品"
                          
                            title="请选择关联商品"
                            :orgCode="orgCode"
                            :categoryOptions="categoryOptions"
                            @changeCommodityList = "changeCommodityList"
                            :commodityList = "form.webNewsCommodityRecommendList"
                            :searchData="glSearchData"
            ></choseCommodity>
        </el-form-item>
        <el-form-item align="center">
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="openclasslSave">保存</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat} from '@/api/utils.js';
  import commodityModel from '@/views/Commodity/commodityModel';
  import choseCommodity from '@/views/Commodity/choseCommodity';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']

  ];
  
  export default {
    components: {
      dateFormat,choseCommodity
  },
    data() {
      return {
        startTimeHoursRule:'00:00:00 - 23:59:59',
        endTimeHoursRule:'00:00:00 - 23:59:59',
        loginOrgCode: '',
        openclasslName: '填写学生感言',
        orgEdit: false,
        showThird: false,
        attachmentList: [],//附件列表
        pictureFileList: [],
        openclassFileList:[],
        dialogVisible: false,
        loaded: false,
        dialogImageUrl: '',
        reFresh: true,
        orgCode: '',
        categoryOptions: [],
        choseCommodityIds: [],
        array1 : [],
        array2 : [],
        choseCommodity: false,
        glSearchData: {
          size: 0,
          page: 1,
          courseName: '',
          ccId: '',
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          orgCode: '',
          isView: 1,
          excludeId: ''
        },
        fileName:'',
         startTime: {
          disabledDate: time => {
            if (this.form.openEndTime) {
              return (
                  time.getTime() >= new Date(this.form.openEndTime).getTime()
              );
            }
          }
        },
        endTime: {
          disabledDate: time => {
            if (this.form.openBeginTime) {
              return (
                  time.getTime() <= new Date(this.form.openBeginTime).getTime() - 1 * 24 * 60 * 60 * 1000
              );
            }
          }
        },
        form: {
          timeall:[],
          openClassName:'',
          openClassNameEn:'',
          ccId: '',
          openClassDate: '',
          openClassBeginTime:'',
          openClassEndTime:'',
          teacherName: '',
          teacherNameEn:'',
          teacherIntroduction:'',
          courseCategoryId: '',
          teacherIntroductionEn:'',
          openClassIntroduction:'',
          openClassIntroductionEn: '',
          openClassPicture:'',
          openClassLink:'',
          openClassAppointmentLink: '',
          id: '',
          orgCode: '',
          // openBeginTime: dateFormat(new Date()),
          // openEndTime: dateFormat(new Date())
          openBeginTime: null,
          openEndTime: null,
          webNewsCommodityRecommendList:[],
        },
        courseOptions: [],
        hidePictureUpload: false,
        selectedCourse: [],
        selectedCategory: [],
        selectedOrgCategory: [],
        categoryOptionsMap: {},
        categoryOrgOptions: [],
        auditionUploadfileList:[],
        categoryOrgOptionsMap: {},
        options: {
          img: '',                         //裁剪图片的地址
          info: true,                      //裁剪框的大小信息
          outputSize: 1,                   // 裁剪生成图片的质量
          outputType: 'jpeg',              //裁剪生成图片的格式
          canScale: false,                 // 图片是否允许滚轮缩放
          autoCrop: true,                  // 是否默认生成截图框
          fixed: false,                    //是否开启截图框宽高固定比例
          fixedNumber: [16, 9]              //截图框的宽高比例
        },
        nationalityList: [],
        videoFlag: false, //是否显示进度条
        videoUploadPercent: 0, //进度条的进度，
        duration: "", //视频时长
        rules: {
          openClassName: [
            {required: true, message: '请输入公开课名称', trigger: 'blur'}
          ],
          courseCategoryId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          openClassNameEn: [
            {required: true, message: '请输入英文公开课名称', trigger: 'blur'}
          ],
          teacherName: [
            {required: true, message: '请输入教师姓名', trigger: 'blur'}
          ],
          teacherNameEn: [
            {required: true, message: '请输入教师英文名字', trigger: 'blur'}
          ],
          openClassLink: [
            {required: true, message: '请输入公开课链接', trigger: 'blur'}
          ],
          openClassIntroduction: [
            {required: true, message: '请输入公开课简介', trigger: 'blur'}
          ],
          openClassIntroductionEn: [
            {required: true, message: '请输入公开课简介英文', trigger: 'blur'}
          ],
          openEndTime:[
          ],
          openBeginTime: [
          ]

        },
        uploadURL: "",
        headers: {
          Authentication: localStorage.getItem('token')
        },

      };
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      changeCommodityList(commoditys) {
        this.choseCommoditys = commoditys;
        let webNewsCommodityRecommendList = [];
        for(let commodity of this.choseCommoditys) {
          let webNewsCommodity = {};
          webNewsCommodity.commodityId = commodity.commodityId;
          webNewsCommodity.recommendName = commodity.courseName;
          webNewsCommodityRecommendList.push(webNewsCommodity);
        }
        this.form.webNewsCommodityRecommendList = webNewsCommodityRecommendList;
      },
      exceed(res, file) {
        console.log(res);
      },
      selectCategoryData(val) {
        if(val == undefined) {
          val = '';
        }
        let params = {
          orgCode: val
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          this.categoryOrgOptions = [];       
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data != null) {
              this.categoryOrgOptions = data.data.data;
              for (let index = 0; index < this.categoryOrgOptions.length; index++) {
                this.array1.push({"ccId":this.categoryOrgOptions[index].ccId,"ccName":this.categoryOrgOptions[index].ccName}); 
              }
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      //加载本部分类
      loadCourseCategory() {
        let params = {
          orgCode: this.$store.state.eblcuOrg
        };
        if(this.loginOrgCode == 'blcuonline') {
          params.orgCode = 'blcuonline'
        }
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.categoryOptions = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      changeCategory(value) {
        this.form.courseCategoryId = value[0];
      },
      imageBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'  || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
      },
      onError (err, file, fileList) {
          console.log("err---",err);

      },
      fengmianHandleSuccess(response, file, fileList) {
        this.openclassFileList = [];
        if(response.code == 200) {
          this.form.openClassPicture = response.data.resourceUrl;
          let file = {
            name: response.data.fileName,
            url: response.data.resourceUrl
          };
          this.openclassFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      pictureOnChange(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      selectItem(value){
        var aid =value;
         console.log(aid);
      },
      //保存资源数据
      openclasslSave() {
        if(this.selectedOrgCategory.length > 0) {
          this.form.courseCategoryId = this.selectedOrgCategory[this.selectedOrgCategory.length-1];
        }
        if(this.form.openBeginTime || this.form.openEndTime) {
          if(!this.form.openBeginTime) {
            this.$message.error('开始时间不能为空！');
            return;
          }
          if(!this.form.openEndTime) {
            this.$message.error('结束时间不能为空！');
            return;
          }
          if(new Date(this.form.openBeginTime).getTime() >= new Date(this.form.openEndTime).getTime()) {
            this.$message.error('开始时间不能大于结束时间！');
            return;
          }
        }
        if(this.form.openBeginTime) {
          this.form.openClassDate = this.form.openBeginTime.split(' ')[0];
          this.form.openClassBeginTime = this.form.openBeginTime.split(' ')[1];
        }
        if(this.form.openEndTime) {
          this.form.openClassEndTime = this.form.openEndTime.split(' ')[1];
              //  this.form.openClassEndTime = this.form.openEndTime;
        }
        let params = this.form;
        this.$refs['openclasslForm'].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          } else {
            let url = '/webOpenClass/addOpenClass';
            if (this.form.id) {
              url = '/webOpenClass/updateOpenClass';
            }
            https.fetchPost(url, params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.$router.push('/openclass/openclass');
              } else {
                this.$message({
                  type: 'info',
                  message: '操作失败：' + msg
                });
              }
            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          }
        });
      },
      reset() {
        this.$refs['openclasslForm'].resetFields();
        // this.form.createTime = dateFormat(new Date(this.form.createTime));
      },

      changeOrg() {
        this.searchCourseType();
        this.form.id = "";
        this.form.ccId = "";
      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      this.uploadURL = this.https.baseURL + '/resources/updateResourceFile';
      this.loadCourseCategory();
      this.selectCategoryData(this.loginOrgCode);
      let dataForm = this.$route.params;
      if (dataForm.id) {
        this.title = '修改公开课信息';
        this.orgEdit = true;
        this.form = dataForm;
        if(this.form.openClassPicture){
            let pictureFile = {
              name: this.form.openClassPicture,
              url: this.form.openClassPicture
            };
            this.openclassFileList.push(pictureFile);
        }
        if(this.form.courseCategoryId != null) {
            this.selectedOrgCategory.push(this.form.courseCategoryId);
        }
        if(this.form.openClassDate != null) {
            this.$set(this.form,'openBeginTime',this.form.openClassDate +" "+this.form.openClassBeginTime);
            this.$set(this.form,'openEndTime',this.form.openClassDate +" "+this.form.openClassEndTime);
        }
        if (this.form.webNewsCommodityRecommendList) {
          let webNewsCommodityRecommendList = [];
          let commodityRecommendList = this.form.webNewsCommodityRecommendList;
          for (let i in commodityRecommendList) {
            let webNewsCommodity = {};
            webNewsCommodity.commodityId = commodityRecommendList[i].commodityId;
            webNewsCommodity.courseName = commodityRecommendList[i].recommendName;
            webNewsCommodityRecommendList.push(webNewsCommodity);
          }       
          this.commodityTags=webNewsCommodityRecommendList;
        }
      } else {
        this.title = '添加公开课信息';
      }
    },
    
  };
</script>

<style>
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9 !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  position: relative !important;
  overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
  border: 1px dashed #d9d9d9 !important;
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 178px;
  display: block;
}
.hide .el-upload--picture-card {
    display: none;
  }
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }


  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;}
</style>
